interface Params {
  /** Name or reply as typed. */
  value: string;
  /** Fewest characters the API takes. */
  min: number;
  /** Most characters the API takes. */
  max: number;
}

/**
 * Whether a name or reply has a length the API takes. Characters are counted as the API counts them, so an emoji is
 * one; spaces at the ends don't count towards the minimum, so a text of only spaces is too short.
 */
export const isTemplateTextLength = ({ value, min, max }: Params) => {
  const { length } = [...value];
  const lengthWithoutEndSpaces = [...value.trim()].length;

  return lengthWithoutEndSpaces >= min && length <= max;
};
